import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StatusUpdateInterface } from "../../models/interfaces/update-status.interface";

export interface ApplicationCancelledStates {
  show_application_cancelled_alert: boolean,
  application_details?: StatusUpdateInterface,
  cancelled_by?: "owner" | "officer"
}

const initialState: ApplicationCancelledStates = {
  show_application_cancelled_alert: false,
  application_details: undefined
};

const ApplicationCancelledSlice = createSlice({
  name: "Application Cancelled Slice",
  initialState,
  reducers: {
    setShowApplicationCancelled: (state, action: PayloadAction<boolean>) => {
      state.show_application_cancelled_alert = action.payload;
    },
    setApplicationDetails: (state, action: PayloadAction<StatusUpdateInterface>) => {
      state.application_details = action.payload;
    },
    setCancelledBy: (state, action: PayloadAction<"owner" | "officer">) => {
      state.cancelled_by = action.payload;
    },
  },
  extraReducers: {},
});

export const { setShowApplicationCancelled, setApplicationDetails, setCancelledBy } = ApplicationCancelledSlice.actions;

export default ApplicationCancelledSlice.reducer;
